import { memo, useState } from 'react';
import { useEditorTool } from '../hooks/useEditorTool';
import { PerformanceManager } from '../ui/PerformanceManager';
import { useEditor, useEditorPerformance } from '../context/EditorSdkProvider';
import { useEditorEvent } from '../hooks/useEditorEvent';

interface Props {
  onDownloadClick: (csvContent: string) => void;
}

/**
 * This component should be used only for Internal use. It is used for monotoring editor performance
 */
export const PerformanceTool: React.FC<Props> = memo(({ onDownloadClick }) => {
  const { isOpen, close } = useEditorTool('editorPerformanceManager');
  const {
    performanceResults,
    isPerformanceMeasuringStarted,
    performanceSelectorXpath,
    togglePerformanceMeasuring,
    handlePerformanceResultsAvgCalculated,
    handlePickSelector,
    handleStopOnSelectorXpathChange,
    hanleRestartButtonClick,
  } = useEditorPerformance();
  const [showBackdrop, setShowBackdrop] = useState(false);
  const editorSdk = useEditor();
  useEditorEvent(editorSdk, 'showBackdropOverlay', setShowBackdrop);

  return (
    <PerformanceManager
      isOpen={isOpen}
      onClose={close}
      onStartStopButtonClick={togglePerformanceMeasuring}
      performanceResults={performanceResults}
      isPerformanceStarted={isPerformanceMeasuringStarted}
      isEditorLoading={!showBackdrop}
      onPerformanceResultsAvgCalculated={handlePerformanceResultsAvgCalculated}
      onDownloadClick={onDownloadClick}
      onPickSelectorClick={handlePickSelector}
      performanceSelectorXpath={performanceSelectorXpath}
      onStopOnSelectorXpathChange={handleStopOnSelectorXpathChange}
      onRestartButtonClick={hanleRestartButtonClick}
    />
  );
});

PerformanceTool.displayName = 'PerformanceTool';
